import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { closeAllModals, closeModal } from '../../store/modal/modal'
import { selectShouldReload, setShouldReload, setUpdateStartedFrom } from '../../store/meetingSummary/contactUpdate'
import { AddAgentResultToCRMModal } from '../../apps/professional-app/fa/MeetingSummary/MeetingSummaryAgent/Header/CRMModal/AddAgentResultToCRMModal'
import { MeetingSummaryDocumentConnectorExportModal } from '../../apps/professional-app/fa/MeetingSummary/MeetingSummaryAgent/MeetingSummaryDocumentConnectorExportModal/MeetingSummaryDocumentConnectorExportModal'
import { UpdateExternalMeetingContactModal } from '../../views/UpdateExternalContact/UpdateExternalContact'
import { TaskSourceType } from '../../views/Tasks/hooks'
import { AddTaskToCRMModal } from '../../views/MeetingSummary/CRM/V2/AddTaskToCRMModal'
import { selectTasks } from '../../store/task/task'
import { IntegrationWorkflowsModal } from '../../apps/professional-app/fa/MeetingSummary/CRM/workflow/IntegrationWorkflowsModal'

export const MeetingSummaryModalManager: React.FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const modals = useAppSelector((state) => state.modal.modals)
  const shouldReload = useAppSelector(selectShouldReload)
  const tasks = useAppSelector(selectTasks)

  useEffect(() => {
    return () => {
      dispatch(closeAllModals())
    }
  }, [dispatch])

  const handleUpdateContactClose = (id: string) => {
    dispatch(closeModal(id))
    dispatch(setUpdateStartedFrom(null))

    if (shouldReload) {
      dispatch(setShouldReload(false))
      navigate(0)
    }
  }

  return (
    <>
      {modals.map((modal) => {
        const { id, type, serviceId, user, roomSession, externalIntegration } = modal

        if (!type || !serviceId) {
          return null
        }

        switch (type) {
          case 'exportMeetingSummary':
            if (!roomSession) {
              return null
            }

            return <AddAgentResultToCRMModal key={id} roomSession={roomSession} show={true} onHide={() => dispatch(closeModal(id))} serviceId={serviceId} />

          case 'saveMeetingSummaryToDocumentConnector':
            return <MeetingSummaryDocumentConnectorExportModal key={id} serviceId={serviceId} onHide={() => dispatch(closeModal(id))} />

          case 'updateContact':
            if (!user) {
              return null
            }

            return <UpdateExternalMeetingContactModal key={id} show={true} user={user} serviceId={serviceId} onClose={() => handleUpdateContactClose(id)} />

          case 'manageWorkflows':
            if (!user) {
              return null
            }

            return <IntegrationWorkflowsModal key={id} show={true} user={user} serviceId={serviceId} onClose={() => dispatch(closeModal(id))} />

          case 'createTask':
            if (!roomSession || !externalIntegration) {
              return null
            }

            return (
              <AddTaskToCRMModal
                key={id}
                show={true}
                onHide={() => dispatch(closeModal(id))}
                tasks={tasks}
                userIntegration={externalIntegration}
                baseTaskDueDate={roomSession.finishedAt ? new Date(roomSession.finishedAt) : null}
                taskContextDetails={{ roomId: roomSession.roomId, sessionId: roomSession.id }}
                type={TaskSourceType.MEETING}
                roomSession={roomSession}
              />
            )

          default:
            return null
        }
      })}
    </>
  )
}
